/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Component, EventEmitter, Inject, Input, Output } from "@angular/core";
import { Observable, of } from "rxjs";
import { JsonApiResource } from "@irian-ro/abstract-resource";
import { LocalAddressSearchService } from "./local-address-search.service";
import { AddressDTO } from "@well/address-management-domain-model";
import { CommonModule } from "@angular/common";
import { LocalAddressListComponent } from "../local-address-list/local-address-list.component";

@Component({
  selector: 'well-local-address-search',
  templateUrl: './local-address-search.component.html',
  styleUrls: ['./local-address-search.component.scss'],
  standalone: true,
  imports: [CommonModule, LocalAddressListComponent],
})
export class LocalAddressSearchComponent {
  private _searchTerm = '';

  localAddresses: Observable<JsonApiResource<AddressDTO[], any>> | undefined = undefined;

  @Output() addressSelect: EventEmitter<AddressDTO> = new EventEmitter<AddressDTO>();

  @Input() set searchTerm(value: string) {
    this._searchTerm = value;
    this.search(value);
  }

  search(event: string) {
    if (event) {
      this.localAddresses = this.localAddressSearchService.getSearchResults(event);
    } else {
      this.localAddresses = of();
    }
  }

  constructor(@Inject(LocalAddressSearchService) private localAddressSearchService: LocalAddressSearchService) {}

  onSelect(event: AddressDTO) {
    const result = new AddressDTO();
    result.addressLine = event.addressLine;
    result.addressTypeValue = event.addressTypeValue;
    result.streetName = event.streetName;
    result.streetNumber = event.streetNumber;
    result.block = event.block;
    result.building = event.building;
    result.floor = event.floor;
    result.apartment = event.apartment;
    result.city = event.city;
    result.country = event.country;
    result.pointDTO = event.pointDTO;
    result.postalCode = event.postalCode;
    result.state = event.state;
    result.details = event.details;
    result.uuid = event.uuid;

    this.addressSelect.next(result);
  }
}
